export const PlayersBattersNameMapped = {
    'AK Markram': { index: 0, country: 'South Africa' },
    'H Klaasen': { index: 1, country: 'South Africa' },
    'Q de Kock': { index: 2, country: 'South Africa' },
    'T Bavuma': { index: 3, country: 'South Africa' },
    'M Labuschagne': { index: 4, country: 'Australia' },
    'GJ Maxwell': { index: 5, country: 'Australia' },
    'R Ravindra': { index: 6, country: 'New Zealand' },
    'GD Phillips': { index: 7, country: 'New Zealand' },
    'Shubman Gill': { index: 8, country: 'India' },
    'SS Iyer': { index: 9, country: 'India' },
    'JM Bairstow': { index: 10, country: 'England' },
    'BA Stokes': { index: 11, country: 'England' },
    'JC Buttler': { index: 12, country: 'England' },
    'RG Sharma': { index: 13, country: 'India' },
    'DA Warner': { index: 14, country: 'Australia' },
    'KL Rahul': { index: 15, country: 'India' },
    'SPD Smith': { index: 16, country: 'Australia' },
    'KS Williamson': { index: 17, country: 'New Zealand' },
    'V Kohli': { index: 18, country: 'India' },
};


export const PlayersBowlerNameMapped = {
    'AU Rashid': { index: 0, country: 'England' },
    'R Ashwin': { index: 1, country: 'India' },
    'TA Boult': { index: 2, country: 'New Zealand' },
    'JJ Bumrah': { index: 3, country: 'India' },
    'PJ Cummins': { index: 4, country: 'Australia' },
    'JR Hazlewood': { index: 5, country: 'Australia' },
    'MJ Henry': { index: 6, country: 'New Zealand' },
    'Kuldeep Yadav': { index: 7, country: 'India' },
    'NM Lyon': { index: 8, country: 'Australia' },
    'Mohammad Nabi': { index: 9, country: 'Afghanistan' },
    'K Rabada': { index: 10, country: 'South Africa' },
    'Shakib Al Hasan': { index: 11, country: 'Bangladesh' },
    'Mohammed Shami': { index: 12, country: 'India' },
    'TG Southee': { index: 13, country: 'New Zealand' },
    'MA Starc': { index: 14, country: 'Australia' },
};

export const BattersName = [
    'AK Markram', 'H Klaasen', 'Q de Kock', 'T Bavuma', 'M Labuschagne',
    'GJ Maxwell', 'R Ravindra', 'GD Phillips', 'Shubman Gill', 'SS Iyer',
    'JM Bairstow', 'BA Stokes', 'JC Buttler', 'RG Sharma', 'DA Warner',
    'KL Rahul', 'SPD Smith', 'KS Williamson', 'V Kohli',
];

export const BowlersName = [
    'AU Rashid', 'R Ashwin', 'TA Boult', 'JJ Bumrah', 'PJ Cummins',
    'JR Hazlewood', 'MJ Henry', 'Kuldeep Yadav', 'NM Lyon', 'Mohammad Nabi',
    'K Rabada', 'Shakib Al Hasan', 'Mohammed Shami', 'TG Southee', 'MA Starc',
];

export const Ground = [
    'Potchefstroom', 'Bloemfontein', 'East London', 'Gqeberha', 'Cape Town',
    'Centurion', 'Johannesburg', 'Durban', 'Galle', 'Colombo (SSC)',
    'Dambulla', 'Colombo (RPS)', 'Kimberley', 'Paarl', 'Perth', 'Adelaide',
    'Hobart', 'The Oval', 'Southampton', 'Cardiff', 'Birmingham', "Lord's",
    'Chester-le-Street', 'Manchester', 'Visakhapatnam', 'Pune', 'Karachi',
    'Rawalpindi', 'Gros Islet', "St George's", 'Dublin (Malahide)', 'Belfast',
    'Abu Dhabi', 'Dubai (DSC)', 'Sharjah', 'Christchurch', 'Leeds', 'Bristol',
    'Thiruvananthapuram', 'Guwahati', 'Indore', 'Lucknow', 'Ranchi', 'Delhi',
    'Sydney', 'Benoni', 'Dharamsala', 'Wankhede', 'Chennai', 'Eden Gardens',
    'Pallekele', 'Carrara', 'Lahore', 'Cuttack', 'Rajkot', 'Bengaluru',
    'Hambantota', 'Chattogram', 'Mirpur', 'Harare', 'Bulawayo', 'Mount Maunganui',
    'Hamilton', 'Melbourne', 'Canberra', 'Auckland', 'Wellington', 'Kanpur',
    'Nagpur', 'Providence', 'Basseterre', 'Bridgetown', 'Dunedin', 'Nottingham',
    'Mohali', 'Brisbane', 'Cairns', 'Ahmedabad', 'Hyderabad', 'Jaipur',
    'Tolerance Oval', 'Taunton', 'Townsville', 'Queenstown', 'Nelson', 'Napier',
    'Edinburgh', 'The Hague', 'Kingston', 'Raipur', 'Port of Spain', 'Roseau',
    'Tarouba', 'Lauderhill', 'North Sound', 'Dublin', 'Multan', 'Aberdeen',
    'Amstelveen', 'Brabourne', 'Kochi', 'Fatullah', 'Colombo (PSS)', 'Kingstown',
    'Vadodara', 'Whangarei', 'Gwalior'
];

export const BowlGround = {
    "Aberdeen": 0,
    "Abu Dhabi": 1,
    "Adelaide": 2,
    "Ahmedabad": 3,
    "Al Amerat": 4,
    "Amstelveen": 5,
    "Auckland": 6,
    "Ayr": 7,
    "Basseterre": 8,
    "Belfast": 9,
    "Bengaluru": 10,
    "Benoni": 11,
    "Birmingham": 12,
    "Bloemfontein": 13,
    "Bogra": 14,
    "Brabourne": 15,
    "Bready": 16,
    "Bridgetown": 17,
    "Brisbane": 18,
    "Bristol": 19,
    "Bulawayo": 20,
    "Cairns": 21,
    "Canberra": 22,
    "Cape Town": 23,
    "Cardiff": 24,
    "Carrara": 25,
    "Centurion": 26,
    "Chattogram": 27,
    "Chelmsford": 28,
    "Chennai": 29,
    "Chester-le-Street": 30,
    "Christchurch": 31,
    "Colombo (PSS)": 32,
    "Colombo (RPS)": 33,
    "Colombo (SSC)": 34,
    "Cuttack": 35,
    "Dambulla": 36,
    "Darwin": 37,
    "Dehradun": 38,
    "Delhi": 39,
    "Dharamsala": 40,
    "Dubai (DSC)": 41,
    "Dublin": 42,
    "Dublin (Malahide)": 43,
    "Dunedin": 44,
    "Durban": 45,
    "East London": 46,
    "Eden Gardens": 47,
    "Edinburgh": 48,
    "Faisalabad": 49,
    "Fatullah": 50,
    "Galle": 51,
    "Geelong": 52,
    "Glasgow": 53,
    "Gqeberha": 54,
    "Greater Noida": 55,
    "Gros Islet": 56,
    "Guwahati": 57,
    "Hambantota": 58,
    "Hamilton": 59,
    "Harare": 60,
    "Hobart": 61,
    "Hyderabad": 62,
    "ICCA Dubai": 63,
    "Indore": 64,
    "Jaipur": 65,
    "Johannesburg": 66,
    "Kanpur": 67,
    "Karachi": 68,
    "Khulna": 69,
    "Kimberley": 70,
    "King City (NW)": 71,
    "Kingston": 72,
    "Kingstown": 73,
    "Kochi": 74,
    "Kuala Lumpur": 75,
    "Lahore": 76,
    "Lauderhill": 77,
    "Leeds": 78,
    "Lord's": 79,
    "Lucknow": 80,
    "Manchester": 81,
    "Melbourne": 82,
    "Mirpur": 83,
    "Mohali": 84,
    "Mount Maunganui": 85,
    "Multan": 86,
    "Nagpur": 87,
    "Nairobi (Gym)": 88,
    "Napier": 89,
    "Nelson": 90,
    "North Sound": 91,
    "Nottingham": 92,
    "Paarl": 93,
    "Pallekele": 94,
    "Perth": 95,
    "Port of Spain": 96,
    "Potchefstroom": 97,
    "Providence": 98,
    "Pune": 99,
    "Queenstown": 100,
    "Raipur": 101,
    "Rajkot": 102,
    "Ranchi": 103,
    "Rawalpindi": 104,
    "Roseau": 105,
    "Rotterdam": 106,
    "Sharjah": 107,
    "Southampton": 108,
    "St George's": 109,
    "St John's": 110,
    "Sydney": 111,
    "Sylhet": 112,
    "Tarouba": 113,
    "Taunton": 114,
    "The Hague": 115,
    "The Oval": 116,
    "Thiruvananthapuram": 117,
    "Toronto": 118,
    "Townsville": 119,
    "Vadodara": 120,
    "Visakhapatnam": 121,
    "Wankhede": 122,
    "Wellington": 123,
    "Whangarei": 124
}

export const BowlerGround = [
    "Aberdeen",
    "Abu Dhabi",
    "Adelaide",
    "Ahmedabad",
    "Al Amerat",
    "Amstelveen",
    "Auckland",
    "Ayr",
    "Basseterre",
    "Belfast",
    "Bengaluru",
    "Benoni",
    "Birmingham",
    "Bloemfontein",
    "Bogra",
    "Brabourne",
    "Bready",
    "Bridgetown",
    "Brisbane",
    "Bristol",
    "Bulawayo",
    "Cairns",
    "Canberra",
    "Cape Town",
    "Cardiff",
    "Carrara",
    "Centurion",
    "Chattogram",
    "Chelmsford",
    "Chennai",
    "Chester-le-Street",
    "Christchurch",
    "Colombo (PSS)",
    "Colombo (RPS)",
    "Colombo (SSC)",
    "Cuttack",
    "Dambulla",
    "Darwin",
    "Dehradun",
    "Delhi",
    "Dharamsala",
    "Dubai (DSC)",
    "Dublin",
    "Dublin (Malahide)",
    "Dunedin",
    "Durban",
    "East London",
    "Eden Gardens",
    "Edinburgh",
    "Faisalabad",
    "Fatullah",
    "Galle",
    "Geelong",
    "Glasgow",
    "Gqeberha",
    "Greater Noida",
    "Gros Islet",
    "Guwahati",
    "Hambantota",
    "Hamilton",
    "Harare",
    "Hobart",
    "Hyderabad",
    "ICCA Dubai",
    "Indore",
    "Jaipur",
    "Johannesburg",
    "Kanpur",
    "Karachi",
    "Khulna",
    "Kimberley",
    "King City (NW)",
    "Kingston",
    "Kingstown",
    "Kochi",
    "Kuala Lumpur",
    "Lahore",
    "Lauderhill",
    "Leeds",
    "Lord's",
    "Lucknow",
    "Manchester",
    "Melbourne",
    "Mirpur",
    "Mohali",
    "Mount Maunganui",
    "Multan",
    "Nagpur",
    "Nairobi (Gym)",
    "Napier",
    "Nelson",
    "North Sound",
    "Nottingham",
    "Paarl",
    "Pallekele",
    "Perth",
    "Port of Spain",
    "Potchefstroom",
    "Providence",
    "Pune",
    "Queenstown",
    "Raipur",
    "Rajkot",
    "Ranchi",
    "Rawalpindi",
    "Roseau",
    "Rotterdam",
    "Sharjah",
    "Southampton",
    "St George's",
    "St John's",
    "Sydney",
    "Sylhet",
    "Tarouba",
    "Taunton",
    "The Hague",
    "The Oval",
    "Thiruvananthapuram",
    "Toronto",
    "Townsville",
    "Vadodara",
    "Visakhapatnam",
    "Wankhede",
    "Wellington",
    "Whangarei"
];


export const Country = [
    'Bangladesh',
    'Zimbabwe',
    'India',
    'Australia',
    'Sri Lanka',
    'Pakistan',
    'England',
    'West Indies',
    'Afghanistan',
    'New Zealand',
    'Ireland',
    'Netherlands',
    'U.A.E.',
    'South Africa',
    'Scotland',
    'Namibia',
    'Nepal',
    'Hong Kong',
    'Kenya',
    'Canada'
];


export const RunRange = {
    0: { 'min': 0, 'max': 30 },
    1: { 'min': 30, 'max': 60 },
    2: { 'min': 60, 'max': 100 },
    3: { 'min': 100, 'max': 150 },
    4: { 'min': 150, 'max': 200 },
    5: { 'min': 200, 'max': '+' },
}

export const CountryIndexing = {
    'Bangladesh': 0,
    'Zimbabwe': 1,
    'India': 2,
    'Australia': 3,
    'Sri Lanka': 4,
    'Pakistan': 5,
    'England': 6,
    'West Indies': 7,
    'Afghanistan': 8,
    'New Zealand': 9,
    'Ireland': 10,
    'Netherlands': 11,
    'U.A.E.': 12,
    'South Africa': 13,
    'Scotland': 14,
    'Namibia': 15,
    'Nepal': 16,
    'Hong Kong': 17,
    'Kenya': 18,
    'Canada': 19,
};

export const ConditionIndexing = {
    'Clear': 0,
    'Partially cloudy': 1,
    'Rain, Partially cloudy': 2,
    'Rain, Overcast': 3,
    'Overcast': 4,
    'Rain': 5,
    'Snow, Partially cloudy': 6,
    'Snow, Rain, Overcast': 7,
    'Snow, Rain, Partially cloudy': 8,
    'Rain, Fog': 9,
    'Snow, Overcast': 10,
};

export const BowlCondition = {
    'Clear': 0,
    'Overcast': 1,
    'Partially cloudy': 2,
    'Rain': 3,
    'Rain, Fog': 4,
    'Rain, Overcast': 5,
    'Rain, Partially cloudy': 6,
    'Snow, Overcast': 7,    
    'Snow, Partially cloudy': 8,
    'Snow, Rain, Overcast': 9,
    'Snow, Rain, Partially cloudy': 10
}

export const BowlOpp = {
    "Afghanistan": 0,
    "Australia": 1,
    "Bangladesh": 2,
    "Bermuda": 3,
    "Canada": 4,
    "England": 5,
    "Hong Kong": 6,
    "India": 7,
    "Ireland": 8,
    "Kenya": 9,
    "Namibia": 10,
    "Nepal": 11,
    "Netherlands": 12,
    "New Zealand": 13,
    "Oman": 14,
    "P.N.G.": 15,
    "Pakistan": 16,
    "Scotland": 17,
    "South Africa": 18,
    "Sri Lanka": 19,
    "U.A.E.": 20,
    "West Indies": 21,
    "Zimbabwe": 22
}
export const BowlOppCountry = [
    "Afghanistan",
    "Australia",
    "Bangladesh",
    "Bermuda",
    "Canada",
    "England",
    "Hong Kong",
    "India",
    "Ireland",
    "Kenya",
    "Namibia",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Oman",
    "P.N.G.",
    "Pakistan",
    "Scotland",
    "South Africa",
    "Sri Lanka",
    "U.A.E.",
    "West Indies",
    "Zimbabwe"
  ];
  


export const GroundIndexing = {
    'Potchefstroom': 0,
    'Bloemfontein': 1,
    'East London': 2,
    'Gqeberha': 3,
    'Cape Town': 4,
    'Centurion': 5,
    'Johannesburg': 6,
    'Durban': 7,
    'Galle': 8,
    'Colombo (SSC)': 9,
    'Dambulla': 10,
    'Colombo (RPS)': 11,
    'Kimberley': 12,
    'Paarl': 13,
    'Perth': 14,
    'Adelaide': 15,
    'Hobart': 16,
    'The Oval': 17,
    'Southampton': 18,
    'Cardiff': 19,
    'Birmingham': 20,
    "Lord's": 21,
    'Chester-le-Street': 22,
    'Manchester': 23,
    'Visakhapatnam': 24,
    'Pune': 25,
    'Karachi': 26,
    'Rawalpindi': 27,
    'Gros Islet': 28,
    "St George's": 29,
    'Dublin (Malahide)': 30,
    'Belfast': 31,
    'Abu Dhabi': 32,
    'Dubai (DSC)': 33,
    'Sharjah': 34,
    'Christchurch': 35,
    'Leeds': 36,
    'Bristol': 37,
    'Thiruvananthapuram': 38,
    'Guwahati': 39,
    'Indore': 40,
    'Lucknow': 41,
    'Ranchi': 42,
    'Delhi': 43,
    'Sydney': 44,
    'Benoni': 45,
    'Dharamsala': 46,
    'Wankhede': 47,
    'Chennai': 48,
    'Eden Gardens': 49,
    'Pallekele': 50,
    'Carrara': 51,
    'Lahore': 52,
    'Cuttack': 53,
    'Rajkot': 54,
    'Bengaluru': 55,
    'Hambantota': 56,
    'Chattogram': 57,
    'Mirpur': 58,
    'Harare': 59,
    'Bulawayo': 60,
    'Mount Maunganui': 61,
    'Hamilton': 62,
    'Melbourne': 63,
    'Canberra': 64,
    'Auckland': 65,
    'Wellington': 66,
    'Kanpur': 67,
    'Nagpur': 68,
    'Providence': 69,
    'Basseterre': 70,
    'Bridgetown': 71,
    'Dunedin': 72,
    'Nottingham': 73,
    'Mohali': 74,
    'Brisbane': 75,
    'Cairns': 76,
    'Ahmedabad': 77,
    'Hyderabad': 78,
    'Jaipur': 79,
    'Tolerance Oval': 80,
    'Taunton': 81,
    'Townsville': 82,
    'Queenstown': 83,
    'Nelson': 84,
    'Napier': 85,
    'Edinburgh': 86,
    'The Hague': 87,
    'Kingston': 88,
    'Raipur': 89,
    'Port of Spain': 90,
    'Roseau': 91,
    'Tarouba': 92,
    'Lauderhill': 93,
    'North Sound': 94,
    'Dublin': 95,
    'Multan': 96,
    'Aberdeen': 97,
    'Amstelveen': 98,
    'Brabourne': 99,
    'Kochi': 100,
    'Fatullah': 101,
    'Colombo (PSS)': 102,
    'Kingstown': 103,
    'Vadodara': 104,
    'Whangarei': 105,
    'Gwalior': 106,
};

export const FormatIndexing = {
    'TEST': 0,
    'ODI': 1,
    'T20I': 2,
};

export const BowlFormat = {
    'ODI': 0,
    'T20I': 1,
    'Test': 2
}

export const FoursRange = {
    0: { 'min': 0, 'max': 5 },
    1: { 'min': 5, 'max': 10 },
    2: { 'min': 10, 'max': 20 },
    3: { 'min': 20, 'max': '+' },
}

export const playersIndexing = {
    'AK Markram': "c351829",
    'H Klaasen': "c351833",
    'Q de Kock': "c351836",
    'T Bavuma': "c244855",
    'M Labuschagne': "c352455",
    'GJ Maxwell': "c352454",
    'R Ravindra': "c351609",
    'GD Phillips': "c351798",
    'Shubman Gill': "c352479",
    'SS Iyer': "c352480",
    'JM Bairstow': "c351851",
    'BA Stokes': "c351568",
    'JC Buttler': "c351850",    
    'RG Sharma': "c352478",
    'DA Warner': "c352449",
    'KL Rahul': "c352485",
    'SPD Smith': "c352448",
    'KS Williamson': "c351812",
    'V Kohli': "c332891",
    'AU Rashid' : "c351567", 
    'R Ashwin' : "c352484", 
    'TA Boult' : "c351612", 
    'JJ Bumrah' : "c352488", 
    'PJ Cummins' : "c352460",
    'JR Hazlewood' : "c352459", 
    'MJ Henry' : "c351607", 
    'Kuldeep Yadav' : "c352490", 
    'NM Lyon' : "c332913", 
    'Mohammad Nabi' : "c352437",
    'K Rabada' : "c351849", 
    'Shakib Al Hasan' : "c351919", 
    'Mohammed Shami' : "c352489", 
    'TG Southee' : "c351797", 
    'MA Starc' : "c352462",
};
